import { Component, Input, signal, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UserPromptService } from '../../services/user-prompt.service';
import { MatExpansionModule } from '@angular/material/expansion';


@Component({
  selector: 'app-side-menu-bar',
  standalone: true,
  templateUrl: './side-menu-bar.component.html',
  styleUrl: './side-menu-bar.component.scss',
  imports: [RouterLink, CommonModule,MatTooltipModule, RouterLinkActive, MatButtonModule, MatDividerModule, MatIconModule, MatExpansionModule],
  encapsulation:ViewEncapsulation.None
})
export class SideMenuBarComponent {
  readonly panelOpenState = signal(false);
  @Input()
  SideBarOpen!: Boolean;
  activePromptLib: boolean = false;
  activeExternalLink: string | null = null; // To track external links
  user_role: any;

  constructor(private userPromptService: UserPromptService,private router: Router) {}

  ngOnInit() {
    this.user_role = localStorage.getItem('user');
    
    this.userPromptService.currentData.subscribe((data:boolean) => {
      this.activePromptLib = data;
    })
  }

  isItemActive(path: string | string[]): boolean {
    if (Array.isArray(path)) {
      return path.some(p => this.router.url.includes(p));
    }
    return this.router.url === path ;

  }

  // For external links (assuming menuName is passed)
  isExternalLinkActive(menuName: string): boolean {
    return false;
    //return this.activeExternalLink === menuName;
    //only need to uncomment this for make external icon link active
  }

  // Set the active state for an external link
  setActiveExternalLink(menuName: string): void {
    this.activeExternalLink = menuName;
  }

  preventRedirect(event: Event): void {
    event.preventDefault();
    // this.SideBarOpen = true;
  }

  redirectPage(data:string) {
    if (data == 'userMgmt') {
      this.router.navigate(['/home/user-configuration']);
    } else if(this.router && data == 'promptMgmt' ) {
      this.router.navigate(['/home/prompt-configuration']);
    } else if ( data == 'catMgmt' ) {
      this.router.navigate(['/home/category-management']);
    } else if ( data == 'modelMgmt' ) {
      this.router.navigate(['/home/model-configuration']);
    }
  }
}
